import {NextPage} from 'next';

import {useNotificationsQuery, useUpdateNotifications} from '#apollo/schema';
import {Screen} from '#component/base';
import {NotificationsForm} from '#component/form';
import {AuthCTAMessages} from '#component/partial';
import {withRequireUserState} from '#component/util/RequireUserState/RequireUserState';
import {useToastQueue} from '#hook';
import {sprinkles} from '#style/sprinkles';

import ProfileHeader from '../Profile/components/ProfileHeader';

export const NotificationsScreen = () => {
  const {data, loading, previousData} = useNotificationsQuery();
  const {addToast} = useToastQueue();
  const [updateNotifications] = useUpdateNotifications();
  const {receiveEmailNotification, receiveSMSNotification} = data?.me || {};

  const handleSubmit = async ({
    receiveEmailNotification = false,
    receiveSMSNotification = false,
  }) => {
    await updateNotifications({
      variables: {input: {receiveEmailNotification, receiveSMSNotification}},
    });
    addToast({children: 'Notification settings updated!'});
  };

  return (
    <Screen
      hideHeader
      hero={<ProfileHeader />}
      contentContainerClassName={sprinkles({
        flex: 'flex',
        content: ['end', 'end', 'center'],
        dir: 'col',
      })}
      loading={loading && !previousData}
      pageName="Notification Settings"
      sidePanelImageUrl="/image/verification-error.jpg">
      <div
        className={sprinkles({
          direction: 'col',
          flex: 'flex',
          height: 'full',
          placeContent: ['end', 'center'],
        })}>
        <AuthCTAMessages
          title="Manage Notifications"
          messages={[
            'By opting into notifications, Tally Health™ can help you stay on-track with reminders throughout your journey.',
            'Any account updates are deemed essential and will be communicated via email regardless of notification selections.',
          ]}
        />

        <NotificationsForm
          onSubmit={handleSubmit}
          receiveEmailNotification={receiveEmailNotification}
          receiveSMSNotification={receiveSMSNotification}
        />
      </div>
    </Screen>
  );
};

export const Notifications: NextPage = withRequireUserState(NotificationsScreen, {
  userState: 'verified',
});
